<template>
  <div v-if="showable" class="order-history-wish-list-info">
    <div class="order-history-wish-list-info__user-icon">
      <AccountIconWh24 :image-url="iconUrl" />
    </div>
    <div class="order-history-wish-list-info__user-nickname">
      {{ nickname }}
    </div>
    <div class="order-history-wish-list-info__text">さんに贈りました</div>
  </div>
</template>

<script>
import AccountIconWh24 from '../../../atoms/account_icons/AccountIconWh24.vue'

export default {
  components: {
    AccountIconWh24
  },
  props: {
    showable: {
      type: Boolean,
      require: true,
      default: false
    },
    iconUrl: {
      type: String,
      require: true,
      default: ''
    },
    nickname: {
      type: String,
      require: true,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.order-history-wish-list-info {
  display: flex;
  align-items: center;

  &__user-icon {
    margin-right: 8px;
  }

  &__user-nickname {
    @extend %body-bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__text {
    @extend %body;
    white-space: nowrap;
  }
}
</style>
